/**
 * @generated SignedSource<<2758dae1115410660a95b136e8ce5810>>
 * @lightSyntaxTransform
 * @nogrep
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

import { ConcreteRequest, Query } from 'relay-runtime';
export type ActiveRecords = "ACTIVE" | "BOTH" | "INACTIVE" | "%future added value";
export type ClassesFilterInput = {
  haveAtLeastOneStudent?: boolean | null | undefined;
  isActive: ActiveRecords;
  siteIds?: ReadonlyArray<string> | null | undefined;
  siteIsActive: ActiveRecords;
};
export type DashboardFiltersSiteQuery$variables = {
  input?: ClassesFilterInput | null | undefined;
};
export type DashboardFiltersSiteQuery$data = {
  readonly classes: {
    readonly nodes: ReadonlyArray<{
      readonly id: string;
      readonly name: string | null | undefined;
      readonly owner: {
        readonly lastName: string | null | undefined;
      } | null | undefined;
      readonly section: string | null | undefined;
    }> | null | undefined;
  } | null | undefined;
};
export type DashboardFiltersSiteQuery = {
  response: DashboardFiltersSiteQuery$data;
  variables: DashboardFiltersSiteQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "input"
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "classesFilterInput",
    "variableName": "input"
  },
  {
    "kind": "Literal",
    "name": "first",
    "value": 100
  }
],
v2 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "id",
  "storageKey": null
},
v3 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "name",
  "storageKey": null
},
v4 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "section",
  "storageKey": null
},
v5 = {
  "alias": null,
  "args": null,
  "kind": "ScalarField",
  "name": "lastName",
  "storageKey": null
};
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "metadata": null,
    "name": "DashboardFiltersSiteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassNodeConnection",
        "kind": "LinkedField",
        "name": "classes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v5/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ],
    "type": "Query",
    "abstractKey": null
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "DashboardFiltersSiteQuery",
    "selections": [
      {
        "alias": null,
        "args": (v1/*: any*/),
        "concreteType": "ClassNodeConnection",
        "kind": "LinkedField",
        "name": "classes",
        "plural": false,
        "selections": [
          {
            "alias": null,
            "args": null,
            "concreteType": "ClassNode",
            "kind": "LinkedField",
            "name": "nodes",
            "plural": true,
            "selections": [
              (v2/*: any*/),
              (v3/*: any*/),
              (v4/*: any*/),
              {
                "alias": null,
                "args": null,
                "concreteType": "UserNode",
                "kind": "LinkedField",
                "name": "owner",
                "plural": false,
                "selections": [
                  (v5/*: any*/),
                  (v2/*: any*/)
                ],
                "storageKey": null
              }
            ],
            "storageKey": null
          }
        ],
        "storageKey": null
      }
    ]
  },
  "params": {
    "cacheID": "5446e6462c704b07ab19f94ad15c2711",
    "id": null,
    "metadata": {},
    "name": "DashboardFiltersSiteQuery",
    "operationKind": "query",
    "text": "query DashboardFiltersSiteQuery(\n  $input: ClassesFilterInput\n) {\n  classes(first: 100, classesFilterInput: $input) {\n    nodes {\n      id\n      name\n      section\n      owner {\n        lastName\n        id\n      }\n    }\n  }\n}\n"
  }
};
})();

(node as any).hash = "e92b4b14179c83bc0a340023098ba87f";

export default node;
